/**
 * Validation logic for Claim Editor
 * Thin wrappers over the canonical rule registry in claim-editor-rules.ts
 */

import {
    ClaimFieldError,
    IClaimEditorRulesData,
    errorsByField,
    groupErrorsBySection,
    validateClaimPayload,
} from './claim-editor-rules';
import { ClaimSectionId } from './claim-editor-sections';

export type { IClaimEditorRulesData as IClaimEditorValidationData } from './claim-editor-rules';
export {
    SUFFIX_MAX_LENGTH,
    SUFFIX_TOO_LONG_MESSAGE,
    isSuffixTooLong,
} from './claim-editor-rules';

/**
 * Validates if the claim can be submitted
 */
export function canSubmitClaim(data: IClaimEditorRulesData): boolean {
    return validateClaimPayload(data).length === 0;
}

/**
 * Gets a list of all validation blockers preventing submission (legacy string[] API)
 */
export function getSubmitBlockers(data: IClaimEditorRulesData): string[] {
    return validateClaimPayload(data).map(e => e.message);
}

/**
 * Structured field-keyed validation errors for nav / banner / jump-to-field.
 */
export function getClaimFieldErrors(data: IClaimEditorRulesData): ClaimFieldError[] {
    return validateClaimPayload(data);
}

export function getClaimErrorsByField(data: IClaimEditorRulesData): Record<string, ClaimFieldError> {
    return errorsByField(validateClaimPayload(data));
}

export function getClaimErrorsBySection(
    data: IClaimEditorRulesData,
): Partial<Record<ClaimSectionId, ClaimFieldError[]>> {
    return groupErrorsBySection(validateClaimPayload(data));
}
